(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["callout-banner"] && !Shopify.designMode) return;
  try {
    const tooltips = document.querySelectorAll('.callout-banner__icon');
  
  function showToolTip(el) {
    let topPosition = el.getBoundingClientRect().top;

    el.classList.remove('callout-banner--bot');
    el.classList.toggle('callout-banner--active');

    if( topPosition <= 180 ) el.classList.add('callout-banner--bot');
  }
  
  if( tooltips.length ) {
    tooltips.forEach((tooltip) => {
      tooltip.addEventListener('mouseenter', function(){ showToolTip(this); });
      tooltip.addEventListener('mouseleave', function(){ showToolTip(this); });
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["custom-swatches"] && !Shopify.designMode) return;
  try {
    function swatchHover() {
    const swatches = document.querySelectorAll('.swatches--product .swatch');
    const selectedColour = document.querySelector('.swatch-colour span');
    if (!swatches.length || !selectedColour) return;

    const currentColour = selectedColour.textContent;

    swatches.forEach((swatch) => {
      swatch.addEventListener('mouseenter', () => (selectedColour.textContent = swatch.dataset.colour));
      swatch.addEventListener('mouseleave', () => (selectedColour.textContent = currentColour));
    });
  }

  function swatchCardImageHover() {
    document.querySelectorAll('product-card .swatches--collection').forEach((container) => {
      const productCard = container.closest('product-card');
      if (!productCard) return;

      const getMainImage = () =>
        productCard.querySelector('slideshow-slide[aria-hidden="false"] img.product-media__image') ||
        productCard.querySelector('img.product-media__image');

      const swapSrc = (img, src, srcset) => {
        img.classList.add('is-fading');
        img.addEventListener('transitionend', function handler() {
          img.removeEventListener('transitionend', handler);
          img.removeAttribute('srcset');
          img.src = src;
          if (srcset) img.srcset = srcset;
          img.classList.remove('is-fading');
        }, { once: true });
      };

      const showHoverImage = (e) => {
        const swatch = e.currentTarget;
        const hoverSrc = swatch.dataset.image;
        if (!hoverSrc) return;

        const img = getMainImage();
        if (!img) return;

        if (!img.dataset.originalSrc) {
          img.dataset.originalSrc = img.currentSrc || img.src;
          if (img.srcset) img.dataset.originalSrcset = img.srcset;
        }

        swapSrc(img, hoverSrc);
      };

      const restoreImage = () => {
        const img = getMainImage();
        if (!img || !img.dataset.originalSrc) return;

        swapSrc(img, img.dataset.originalSrc, img.dataset.originalSrcset);

        delete img.dataset.originalSrc;
        delete img.dataset.originalSrcset;
      };

      container.querySelectorAll('.swatch[data-image]').forEach((swatch) => {
        swatch.addEventListener('pointerenter', showHoverImage);
        swatch.addEventListener('pointerleave', restoreImage);
        swatch.addEventListener('focusin', showHoverImage);
        swatch.addEventListener('focusout', restoreImage);
      });
    });
  }

  swatchHover();
  swatchCardImageHover();

  let fabricSelect = document.querySelector('.js-sofa-fabric-select');
  let allSwatches = document.querySelectorAll('.js-sofa-material');

  if (allSwatches.length) {
    if (fabricSelect) {
      showSwatches(fabricSelect.value, allSwatches, false);
      fabricSelect.addEventListener('change', function () {
        showSwatches(this.value, allSwatches, true);
        swatchHover();
      });
    } else {
      allSwatches.forEach((swatch) => {
        if (!swatch.closest('product-card')) {
          swatch.style.display = 'block';
        }
      });
    }
  }

  function showSwatches(material, allSwatches, newActive) {
    let activeSwatchEl = document.querySelector('.swatch--active');
    let activeSwatch = activeSwatchEl ? activeSwatchEl.dataset.colour.toLowerCase() : '';

    allSwatches.forEach((swatch) => {
      if (swatch.dataset.material === material) {
        swatch.style.display = 'block';

        if (newActive) {
          let visibleSwatch =
            Array.from(swatch.querySelectorAll('.swatch')).find(
              (el) => el.dataset.colour.toLowerCase() === activeSwatch
            ) || swatch.querySelector('.swatch'); // fallback to first
          visibleSwatch?.click();
        }
      } else {
        swatch.style.display = 'none';
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["text"] && !Shopify.designMode) return;
  try {
    function readMore(el) {
    let parent = el.closest('.truncated-text');
    let child = parent.querySelector('.truncated-text__inner');

    if (el.getAttribute("status") == 'closed') {
      el.setAttribute("status", "open");
      el.innerText = el.getAttribute("read-less");
      child.classList.remove('truncated-text__inner--hidden');
    } else {
      el.setAttribute("status", "closed");
      el.innerText = el.getAttribute("read-more");
      child.classList.add('truncated-text__inner--hidden');
    }
  }

  const allToggles = document.querySelectorAll('.js-read-more-toggle');

  if(allToggles.length) {
    allToggles.forEach((toggle) => {
      toggle.addEventListener('click', function(){
        readMore(this);
      });
    });
  }
  } catch(e) { console.error(e); }
})();

})();
